<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        small
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="pb-0">
        <v-text-field
          v-model="amount"
          v-validate="'required'"
          v-money="money"
          label="Salary"
          :error-messages="errors.collect('amount')"
          data-vv-name="amount"    
          data-vv-as="amount" 
          prefix="RM"
        />
        <v-text-field
          v-model="days"
          v-validate="'required|nearestZeroPointFive|minDay|maxDay'"
          :error-messages="errors.collect('days')"
          data-vv-name="days"    
          data-vv-as="days" 
          suffix="Days"
          type="number"
          :min="0"
          @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          class="white--text"
          color="hrissecondary"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
        required: true,
      },
      payrollCycleTransaction: {
        type: Object,
        required: true,
      },
      payrollPeriod: {
        type: Object,
        required: true,
      },
      salary: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        remark: null,
        days: null,
        amount: 0,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },

    watch: {
      menu: function (value) {
        let _this = this

        this.amount = this.salary

        this.$validator.extend('nearestZeroPointFive', {
          getMessage (field, args) {
            return 'Please enter days to the nearest 0.5'
          },
          validate (value, args) {
            return _this.isTheNearestZeroPointFiveNumbers(value)
          },
        })
        this.$validator.extend('minDay', {
          getMessage (field, args) {
            return 'Please enter a valid day'
          },
          validate (value, args) {
            return value > 0
          },
        })
        this.$validator.extend('maxDay', {
          getMessage (field, args) {
            return 'Exceeded days for the payroll month'
          },
          validate (value, args) {
            return _this.getDaysInPayrollMonth(value)
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.progressing = true

            this.$api.payrollCyclePartTimeEmployeeSalaries().create(this.payrollCycleTransaction.id, this.prepareFormData())
              .then(response => {
                if (response.status === 201) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.menu = false
                }
              })
              .catch(error => {
                if (error.response.status >= 400 && error.response.status < 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          company_employee_uid: this.companyEmployeeUid,
          amount: this.amount.toString().replaceAll(',', ''),
          unit: this.days,
          unit_of_measurement: 'days',
        }
      },
      isTheNearestZeroPointFiveNumbers (value) {
        return value % 0.5 === 0
      },
      getDaysInPayrollMonth (value) {
        return value <= this.$moment(this.payrollPeriod.payroll_date).daysInMonth()
      },
    },
  }
</script>
